<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">
      Silahkan Mengunggah Kelengkapan Dokumen Legalitas
    </p>

    <div class="legalitas-wrapper">
      <div class="vendor-form-wrapper legalitas-padding">
        <div class="vendor-form">
          <div class="legalitas-form-label">
            KTP<span class="text-ast">*</span>
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left"></div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ ktpFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileKtpChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div class="legalitas-form-label">NPWP</div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left"></div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ npwpFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileNpwpChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Kartu Keluarga<span class="text-ast">*</span>
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left"></div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ kkFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileKkChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Cover Depan Rekening Tabungan<span class="text-ast">*</span>
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left"></div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ coverFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileCoverChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Surat Rekomendasi dari Pemerintah Daerah Setempat
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-checkbox">
                  <input
                    class="legal-checkbox-input"
                    type="checkbox"
                    v-model="$store.state.landingpage.adaRekomendasi"
                  />
                  <div>
                    {{
                      $store.state.landingpage.adaRekomendasi
                        ? 'Ada'
                        : 'Tidak ada'
                    }}
                  </div>
                </div>
                <div
                  class="column50"
                  v-if="$store.state.landingpage.adaRekomendasi"
                >
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ rekomendasiFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileRekomendasiChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Rekening Koran 3 Bulan Terakhir
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-checkbox">
                  <input
                    class="legal-checkbox-input"
                    type="checkbox"
                    v-model="$store.state.landingpage.adaRekening"
                  />
                  <div>
                    {{
                      $store.state.landingpage.adaRekening ? 'Ada' : 'Tidak ada'
                    }}
                  </div>
                </div>
                <div
                  class="column50"
                  v-if="$store.state.landingpage.adaRekening"
                >
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ rekeningFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileRekeningChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vendor-form-wrapper legalitas-padding">
        <!-- <div class="vendor-form">
          <div class="legalitas-form-label">Logo Perusahaan</div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left"></div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span>{{ logoFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileLogoChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Surat Pakta Integritas yang sudah di tanda tangan basah oleh
            Direktur Utama Perusahaan diatas materai Rp 10.000
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label
                    class="btn btn-default btn-file column100"
                    @click="paktaIntegritas()"
                  >
                    <i class="fas fa-download"></i>
                    <span>Unduh Templat</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ paktaFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="filePaktaChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Formulir vendor yang sudah di tanda tangan basah oleh Direktur Utama
            Perusahaan diatas materai Rp 10.000
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label
                    class="btn btn-default btn-file column100"
                    @click="pdfFormVendor()"
                  >
                    <i class="fas fa-download"></i>
                    <span>Unduh Templat</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ formulirFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileFormulirChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="vendor-form">
          <div class="legalitas-form-label">
            Surat Keterangan Perusahaan non PKP yang sudah di tanda tangan basah
            oleh Direktur Utama Perusahaan diatas materai Rp 10.000<span
              class="text-ast"
              >*</span
            >
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label
                    class="btn btn-default btn-file column100"
                    @click="pdfNonPkp()"
                  >
                    <i class="fas fa-download"></i> <span>Unduh Templat</span>
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span>{{ suratFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileSuratChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="vendor-form">
          <div class="legalitas-form-label">
            Surat Komitmen KPLH yang sudah di tanda tangan basah diatas materai
            RP 10.000, dan saat ini tidak di buatkan mandatory
          </div>
          <div class="legalitas-up-down">
            <div class="list-usaha">
              <div class="list-usaha-content">
                <div class="column50 legal-icon-left">
                  <label
                    class="btn btn-default btn-file column100"
                    @click="pdfKomitmen()"
                  >
                    <i class="fas fa-download"></i> <span>Unduh Templat</span>
                    <!-- <input type="file" style="display: none;" /> -->
                  </label>
                </div>
                <div class="column50">
                  <label class="btn btn-default btn-file column100">
                    <i class="fas fa-upload"></i>
                    <span class="all-column">{{ komitmenKplhFileName }}</span>
                    <input
                      type="file"
                      style="display: none;"
                      @change="fileKomitmenKplhChangeHandler"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goSelesai()" class="btn-landing">Selanjutnya</div>
    </div>

    <AddAktaPerusahaan v-if="$store.state.landingpage.addAktaPerusahaan" />
    <AddKomersial v-if="$store.state.landingpage.addKomersial" />
    <AddPerizinan v-if="$store.state.landingpage.addPerizinan" />
  </div>
</template>

<script>
export default {
  components: {
    AddAktaPerusahaan: () =>
      import('@/components/modalLandingPage/addAktaPerusahaan.vue'),
    AddKomersial: () =>
      import('@/components/modalLandingPage/addKomersial.vue'),
    AddPerizinan: () =>
      import('@/components/modalLandingPage/addPerizinan.vue'),
  },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {
    ktpFileName() {
      if (
        this.$store.state.landingpage.ktpFiles.length > 0 &&
        'name' in this.$store.state.landingpage.ktpFiles[0]
      ) {
        return this.$store.state.landingpage.ktpFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.ktpFileName')) {
        return this.$get(this.$store, 'state.landingpage.ktpFileName')
      }
      return this.labelPlaceholder
    },
    npwpFileName() {
      if (
        this.$store.state.landingpage.npwpFiles.length > 0 &&
        'name' in this.$store.state.landingpage.npwpFiles[0]
      ) {
        return this.$store.state.landingpage.npwpFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.npwpFileName')) {
        return this.$get(this.$store, 'state.landingpage.npwpFileName')
      }
      return this.labelPlaceholder
    },
    kkFileName() {
      if (
        this.$store.state.landingpage.kkFiles.length > 0 &&
        'name' in this.$store.state.landingpage.kkFiles[0]
      ) {
        return this.$store.state.landingpage.kkFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.kkFileName')) {
        return this.$get(this.$store, 'state.landingpage.kkFileName')
      }
      return this.labelPlaceholder
    },
    coverFileName() {
      if (
        this.$store.state.landingpage.coverFiles.length > 0 &&
        'name' in this.$store.state.landingpage.coverFiles[0]
      ) {
        return this.$store.state.landingpage.coverFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.coverFileName')) {
        return this.$get(this.$store, 'state.landingpage.coverFileName')
      }
      return this.labelPlaceholder
    },
    rekomendasiFileName() {
      if (
        this.$store.state.landingpage.rekomendasiFiles.length > 0 &&
        'name' in this.$store.state.landingpage.rekomendasiFiles[0]
      ) {
        return this.$store.state.landingpage.rekomendasiFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.rekomendasiFileName')) {
        return this.$get(this.$store, 'state.landingpage.rekomendasiFileName')
      }
      return this.labelPlaceholder
    },
    rekeningFileName() {
      if (
        this.$store.state.landingpage.rekeningFiles.length > 0 &&
        'name' in this.$store.state.landingpage.rekeningFiles[0]
      ) {
        return this.$store.state.landingpage.rekeningFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.rekeningFileName')) {
        return this.$get(this.$store, 'state.landingpage.rekeningFileName')
      }
      return this.labelPlaceholder
    },
    logoFileName() {
      if (
        this.$store.state.landingpage.logoFiles.length > 0 &&
        'name' in this.$store.state.landingpage.logoFiles[0]
      ) {
        return this.$store.state.landingpage.logoFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.logoFileName')) {
        return this.$get(this.$store, 'state.landingpage.logoFileName')
      }

      return this.labelPlaceholder
    },
    paktaFileName() {
      if (
        this.$store.state.landingpage.paktaFiles.length > 0 &&
        'name' in this.$store.state.landingpage.paktaFiles[0]
      ) {
        return this.$store.state.landingpage.paktaFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.paktaFileName')) {
        return this.$get(this.$store, 'state.landingpage.paktaFileName')
      }
      return this.labelPlaceholder
    },
    formulirFileName() {
      if (
        this.$store.state.landingpage.formulirFiles.length > 0 &&
        'name' in this.$store.state.landingpage.formulirFiles[0]
      ) {
        return this.$store.state.landingpage.formulirFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.formulirFileName')) {
        return this.$get(this.$store, 'state.landingpage.formulirFileName')
      }
      return this.labelPlaceholder
    },
    suratFileName() {
      if (
        this.$store.state.landingpage.suratFiles.length > 0 &&
        'name' in this.$store.state.landingpage.suratFiles[0]
      ) {
        return this.$store.state.landingpage.suratFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.suratFileName')) {
        return this.$get(this.$store, 'state.landingpage.suratFileName')
      }
      return this.labelPlaceholder
    },
    komitmenKplhFileName() {
      if (
        this.$store.state.landingpage.komitmenKplhFiles.length > 0 &&
        'name' in this.$store.state.landingpage.komitmenKplhFiles[0]
      ) {
        return this.$store.state.landingpage.komitmenKplhFiles[0].name
      }

      if (this.$get(this.$store, 'state.landingpage.komitmenKplhFileName')) {
        return this.$get(this.$store, 'state.landingpage.komitmenKplhFileName')
      }
      return this.labelPlaceholder
    },
    addedAktaPerusahaan: function() {
      return this.$store.state.landingpage.addedAktaPerusahaan
    },
    addedKomersial: function() {
      return this.$store.state.landingpage.addedKomersial
    },
    addedPerizinan: function() {
      return this.$store.state.landingpage.addedPerizinan
    },
  },
  methods: {
    checkForm() {
      const {
        ktpFiles,
        kkFiles,
        coverFiles,
        suratFiles,
        formulirFiles,
        paktaFiles,
        komitmenKplhFiles,
        adaRekomendasi,
        adaRekening,
        rekomendasiFiles,
        rekeningFiles,
      } = this.$store.state.landingpage
      let pageName = this.$route.path

      let arr = [
        [ktpFiles.length > 0 || this.ktpFileName, 'KTP'],
        [kkFiles.length > 0 || this.kkFileName, 'Kartu Keluarga'],
        [
          coverFiles.length > 0 || this.coverFileName,
          'Cover Depan Rekening Tabungan',
        ],
      ]

      if (
        adaRekomendasi &&
        pageName.split('/')[1] != 'review-from-landing-page' &&
        adaRekomendasi &&
        pageName.split('/')[1] != 'review-landing-page'
      ) {
        arr = [
          [
            rekomendasiFiles.length > 0,
            'Surat Rekomendasi dari Pemerintah Daerah Setempat',
          ],
          ...arr,
        ]
      }
      if (
        adaRekening &&
        pageName.split('/')[1] != 'review-from-landing-page' &&
        adaRekening &&
        pageName.split('/')[1] != 'review-landing-page'
      ) {
        arr = [
          [rekeningFiles.length > 0, 'Rekening Koran 3 Bulan Terakhir'],
          ...arr,
        ]
      }

      if (
        this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') == 1
      ) {
        return this.multiConditions(arr)
      }
      return true
    },
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
    },
    goSelesai() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'selesai')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'end_step',
          value: true,
        })
      }
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
    fileKtpChangeHandler(e) {
      let ktpFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'ktpFiles',
        value: ktpFiles,
      })
    },
    fileNpwpChangeHandler(e) {
      let npwpFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'npwpFiles',
        value: npwpFiles,
      })
    },
    fileKkChangeHandler(e) {
      let kkFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'kkFiles',
        value: kkFiles,
      })
    },
    fileCoverChangeHandler(e) {
      let coverFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'coverFiles',
        value: coverFiles,
      })
    },

    fileRekomendasiChangeHandler(e) {
      let rekomendasiFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'rekomendasiFiles',
        value: rekomendasiFiles,
      })
    },
    fileRekeningChangeHandler(e) {
      let rekeningFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'rekeningFiles',
        value: rekeningFiles,
      })
    },

    fileLogoChangeHandler(e) {
      let logoFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'logoFiles',
        value: logoFiles,
      })
    },
    filePaktaChangeHandler(e) {
      let paktaFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'paktaFiles',
        value: paktaFiles,
      })
    },
    fileFormulirChangeHandler(e) {
      let formulirFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'formulirFiles',
        value: formulirFiles,
      })
    },
    fileSuratChangeHandler(e) {
      let suratFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'suratFiles',
        value: suratFiles,
      })
    },
    fileKomitmenKplhChangeHandler(e) {
      let komitmenKplhFiles = Array.from(e.target.files)
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'komitmenKplhFiles',
        value: komitmenKplhFiles,
      })
    },
    fileAktaChangeHandler(e, i) {
      let oldAktaPerusahaan = this.$store.state.landingpage.addedAktaPerusahaan

      let aktaFiles = Array.from(e.target.files)

      oldAktaPerusahaan[i]['file'] = aktaFiles
      oldAktaPerusahaan[i]['fileName'] = aktaFiles[0].name

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addedAktaPerusahaan',
        value: [],
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addedAktaPerusahaan',
        value: oldAktaPerusahaan,
      })
    },
    fileKomersialChangeHandler(e, i) {
      let oldKomersial = this.$store.state.landingpage.addedKomersial

      let komersialFiles = Array.from(e.target.files)

      oldKomersial[i]['file'] = komersialFiles
      oldKomersial[i]['fileName'] = komersialFiles[0].name

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addedKomersial',
        value: [],
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addedKomersial',
        value: oldKomersial,
      })
    },
    filePerizinanChangeHandler(e, i) {
      let oldPerizinan = this.$store.state.landingpage.addedPerizinan

      let perizinanFiles = Array.from(e.target.files)

      oldPerizinan[i]['file'] = perizinanFiles
      oldPerizinan[i]['fileName'] = perizinanFiles[0].name

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addedPerizinan',
        value: [],
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addedPerizinan',
        value: oldPerizinan,
      })
    },
    openModalAktaPerusahaan() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addAktaPerusahaan',
        value: true,
      })
    },
    openModalKomersial() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addKomersial',
        value: true,
      })
    },
    openModalPerizinan() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPerizinan',
        value: true,
      })
    },
    generateAlamat() {
      if (this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63) {
        let alamat = this.$get(this.$store, 'state.landingpage.address', '')
        let kecamatan = this.$get(
          this.$store,
          'state.landingpage.choosedDistric.desc',
          ''
        )
        let kelurahan = this.$get(
          this.$store,
          'state.landingpage.choosedVillage.desc',
          ''
        )
        let kota = this.$get(
          this.$store,
          'state.landingpage.choosedCity.desc',
          ''
        )
        let provinsi = this.$get(
          this.$store,
          'state.landingpage.choosedProvince.desc',
          ''
        )
        let kodepos = this.$get(this.$store, 'state.landingpage.kodepos', '')

        let createAlamat = `${alamat} ${kecamatan &&
          `, ${kecamatan}`} ${kelurahan && `, ${kelurahan}`} ${kota &&
          `, ${kota}`} ${provinsi && `, ${provinsi}`} ${kodepos &&
          `, ${kodepos}`}`

        return createAlamat
      } else {
        let alamat = this.$get(this.$store, 'state.landingpage.address', '')
        let kota = this.$get(this.$store, 'state.landingpage.kotaAsing', '')
        let provinsi = this.$get(
          this.$store,
          'state.landingpage.provinsiAsing',
          ''
        )
        let kodepos = this.$get(this.$store, 'state.landingpage.kodepos', '')

        let alamatInter = `${alamat} ${kota && `, ${kota}`} ${provinsi &&
          `, ${provinsi}`} ${kodepos && `, ${kodepos}`}`

        return alamatInter
      }
    },
    paktaIntegritas() {
      let dataForm = {
        nama: this.$get(this.$store, 'state.landingpage.vendorName', ''),
        jabatan: 'Pemilik',
        perusahaan: '-',
        alamat: this.generateAlamat(),
      }
      let routeData = ''
      routeData = this.$router.resolve({
        path: '/pdf/pakta-integritas',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
    pdfNonPkp() {
      let dataForm = {
        nama: this.$get(this.$store, 'state.landingpage.vendorName', ''),
        jabatan: 'Pemilik',
        perusahaan: '-',
        alamat: this.generateAlamat(),
      }

      let routeData = this.$router.resolve({
        path: '/pdf/surat-pernyataan-non-pkp',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
    pdfKomitmen() {
      let dataForm = {
        nama: this.$get(this.$store, 'state.landingpage.vendorName', ''),
        alamat: this.generateAlamat(),
        phone: `${this.$get(
          this.$store,
          'state.landingpage.phoneCode',
          ''
        )}${this.$get(this.$store, 'state.landingpage.phoneNumber', '')}`,
      }

      let routeData = this.$router.resolve({
        path: '/pdf/komitmen-keselamatan-tambang',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
    pdfFormVendor() {
      let kec = ''
      let kota = ''
      if (this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63) {
        kec = `${this.$get(
          this.$store,
          'state.landingpage.choosedDistric.desc',
          ''
        )} ${`${
          this.$get(this.$store, 'state.landingpage.choosedVillage.desc')
            ? `, ${this.$get(
                this.$store,
                'state.landingpage.choosedVillage.desc'
              )}`
            : ''
        }`}`
        kota = `${this.$get(
          this.$store,
          'state.landingpage.choosedCity.desc',
          ''
        )} ${`${
          this.$get(this.$store, 'state.landingpage.choosedProvince.desc')
            ? `, ${this.$get(
                this.$store,
                'state.landingpage.choosedProvince.desc'
              )}`
            : ''
        }`}`
      } else {
        kec = ``
        kota = `${this.$get(
          this.$store,
          'state.landingpage.kotaAsing',
          ''
        )} ${`${
          this.$get(this.$store, 'state.landingpage.provinsiAsing')
            ? `, ${this.$get(this.$store, 'state.landingpage.provinsiAsing')}`
            : ''
        }`}`
      }
      let dataForm = {
        kbli1: this.$get(this.$store, 'state.landingpage.addedKbli.0.desc', ''),
        kbli2: this.$get(this.$store, 'state.landingpage.addedKbli.1.desc', ''),
        kbli3: this.$get(this.$store, 'state.landingpage.addedKbli.2.desc', ''),
        kec,
        kota,
        kodepos: this.$get(this.$store, 'state.landingpage.kodepos', ''),
        email: this.$get(this.$store, 'state.landingpage.emailPerusahaan', ''),
        nama_bank: this.$get(this.$store, 'state.landingpage.selectedBank', ''),
        bank_cabang: this.$get(
          this.$store,
          'state.landingpage.bankBranchOffice',
          ''
        ),
        pemilik_rekening: this.$get(
          this.$store,
          'state.landingpage.pemilikBank',
          ''
        ),

        afiliasi:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? 'YA'
            : 'TIDAK',
        relasi_desc:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_desc', '')
            : '',
        relasi_group:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_group', '')
            : '',
        relasi_jabatan:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_jabatan', '')
            : '',
        relasi_departemen:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_departemen', '')
            : '',
        relasi_nama:
          this.$get(this.$store, 'state.landingpage.pick', '') == 'ya'
            ? this.$get(this.$store, 'state.landingpage.relasi_nama', '')
            : '',

        doc_ktp: this.ktpFileName != 'UPLOAD' ? 'YA' : 'TIDAK',
        doc_npwp: this.npwpFileName != 'UPLOAD' ? 'YA' : 'TIDAK',
        doc_kk: this.kkFileName != 'UPLOAD' ? 'YA' : 'TIDAK',
        doc_cover: this.coverFileName != 'UPLOAD' ? 'YA' : 'TIDAK',
        doc_rekomendasi: this.rekomendasiFileName != 'UPLOAD' ? 'YA' : 'TIDAK',
        doc_rekening: this.rekeningFileName != 'UPLOAD' ? 'YA' : 'TIDAK',

        no_rek: this.$get(this.$store, 'state.landingpage.accountNumber', ''),
        mata_uang: this.$get(this.$store, 'state.landingpage.mataUang', ''),
        npwp: this.$get(this.$store, 'state.landingpage.npwpBank', ''),

        nama: this.$get(this.$store, 'state.landingpage.vendorName', ''),
        jabatan: 'Pemilik',
        perusahaan: this.$store.state.landingpage.badan_usaha_id,
        alamat: this.$get(this.$store, 'state.landingpage.address', ''),
        no_tlp: `${this.$get(
          this.$store,
          'state.landingpage.phoneNumber',
          ''
        )}`,
      }

      let routeData = ''

      routeData = this.$router.resolve({
        path: '/pdf/form-vendor-perorangan',
        query: dataForm,
      })

      window.open(routeData.href, '_blank')
    },
  },
}
</script>
